{
  "version": 1,
  "asset_id": "5f8daa6d-da4e-45e7-a9a5-41c7e25c435c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5f8daa6d-da4e-45e7-a9a5-41c7e25c435c/sleeve-excess-weight-loss-percentage-graph.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5f8daa6d-da4e-45e7-a9a5-41c7e25c435c/sleeve-excess-weight-loss-percentage-graph.png",
  "original_filename": "sleeve-excess-weight-loss-percentage-graph.png",
  "size": 79484,
  "content_type": "image/webp",
  "created_at": "2026-07-29T11:44:16Z"
}
